<template>
  <div class="stepContainer">
    <div :style="`height:${stepData.length * 60}px`">
      <el-steps direction="vertical">
        <el-step v-for="(item,index) in stepData" :status="stepState(item.state)" :key="index">
          <div slot="title">
            <div style="display:flex;width:80%;align-items:center;justify-content:space-between;color:#000;">
              <span>{{item.title}}<span style="margin-left: 20px">{{item.statusStr}}</span></span>
              <span style="font-size: 14px;">{{item.time}}</span>
            </div>
          </div>
          <div slot="description"><span style="margin-left: 30px;color: rgb(147, 147, 147);">{{item.remark}}</span></div>
        </el-step>
      </el-steps>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return {
    }
  },
  props: {
    stepData: {
      default: [],
    },
    stepState: {
      default: function (){}
    },
  },
  methods: {
  },
  mounted(){
  }
}
</script>

<style lang="scss" scoped>
.stepContainer{
  margin: 10px 0 10px 20px;
  ::v-deep{
    .el-step__icon-inner{
      display:none;
    }
    .el-step__icon-inner.is-status{
      display:block!important;
    }
  }
}
</style>
